const amountTypeOptions = {
  MULTI_PACK: "MULTI_PACK",
  PALLET: "PALLET",
  PIECES: "PIECES",
  MULTI_PACK_SETTINGS: "MULTI_PACK_SETTINGS",
  PALLET_SETTINGS: "PALLET_SETTINGS",
};

export default amountTypeOptions;
